"use strict";

var _interopRequireDefault = require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _BeginnerList = _interopRequireDefault(require("./components/BeginnerList.vue"));
var _PersonalizedConfiguration = _interopRequireDefault(require("./components/PersonalizedConfiguration.vue"));
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'BeginnerCourse',
  components: {
    PersonalizedConfiguration: _PersonalizedConfiguration.default,
    BeginnerList: _BeginnerList.default
  },
  data: function data() {
    return {
      activeName: 'Module'
    };
  },
  methods: {
    handleClick: function handleClick(tab, event) {
      console.log(tab, event);
    }
  }
};